import { createContext } from 'react';
import { getQueryVariable } from '../../../../ui-kitchen/src/utils';

const IframeHostContext = createContext({});

function IframeHost(setSignal) {
  this.dimensions = null;
  this.scrollTop = null;

  return {
    getDimensions,
    setDimensions,
    getScrollTop,
    setScrollTop,
  };

  function getDimensions() {
    return this.dimensions;
  }

  function setDimensions(dimensions) {
    this.dimensions = dimensions;
  }

  function getScrollTop() {
    return this.scrollTop;
  }

  function setScrollTop(scrollTop) {
    this.scrollTop = scrollTop;
    setSignal({ name: 'SCROLL_TOP', args: scrollTop });
  }
}

const initIframeHost = (setSignal) => {
  const iframeHost = new IframeHost(setSignal);

  iframeHost.setDimensions({
    innerHeight: getQueryVariable('innerHeight'),
    innerWidth: getQueryVariable('innerWidth'),
  });

  window.addEventListener('message', (e) => {
    if (e.data.hostDimensions) {
      iframeHost.setDimensions(e.data.hostDimensions);
    }
    if (e.data.scrollTop) {
      iframeHost.setScrollTop(e.data.scrollTop);
    }
  });

  return iframeHost;
};

export { initIframeHost };
export default IframeHostContext;
